<template>
  <div>
    <ots-main-title></ots-main-title>
    <ots-table-group-new
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeNum"
      @changePage="changePage"
      @search="search"
    ></ots-table-group-new>

    <ots-custom-dialog :dialog.sync="showDialog" title="查看考生详情" width="640px">
      <template v-slot:content>
        <div class="studentInfo">
          <p><span>考生姓名：</span><span>{{dialogForm.studentName}}</span></p>
          <p><span>准考证号：</span><span>{{dialogForm.entranceCode}}</span></p>
          <p><span>证件号：</span><span>{{dialogForm.cardNo}}</span></p>
          <p><span>考试科目：</span><span>{{dialogForm.courseName}}</span></p>
        </div>
        <div class="stepUp" v-if="activities.length > 0">
          <div class="radio">
            排序：
            <el-radio-group v-model="reverse" style="padding-top: 10px; box-sizing: border-box">
              <el-radio :label="true">倒序</el-radio>
              <el-radio :label="false">正序</el-radio>
            </el-radio-group>
          </div>

          <el-timeline :reverse="reverse" class="timeline">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              color="#006aff"
              :timestamp="activity.nodeTime"
            >
              {{activity.nodeName}}<br />
              <img
                :src="activity.dataContent"
                width="100"
                height="100"
                class="imgCss"
                v-if="activity.dataType === 'Url'"
                @click="showBigImg(activity.dataContent)">
              </img>
            </el-timeline-item>
          </el-timeline>
        </div>
      </template>
    </ots-custom-dialog>
  </div>
</template>
<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { examStudentQueryListAPI, queryDetailListAPI } from "@/http/modules/computedRoomExam";
import { getPlanAllSessionByPlan } from "@/http/modules/examSet/planClass";
import { getPlanCourseList } from "@/http/modules/custom";
export default {
  data() {
    return {
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '场次',
          type: 'select',
          requestKey: 'sessionId',
          label: 'name',
          value: 'id',
          data: [],
        },
        {
          title: '课程名称',
          type: 'select',
          requestKey: 'courseId',
          label: 'courseName',
          value: 'courseId',
          data: [],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "keyWords",
          placeholder: "姓名/准考证/证件号",
        },
      ],
      requestForm: {
        planId: "",
        sessionId: "",
        courseId: "",
        keyWords: "",
        page: 1,
        size: 10,
      },
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "场次",
          prop: "sessionName"
        },
        {
          title: "姓名",
          prop: "studentName",
        },
        {
          title: "准考证号",
          prop: "entranceCode",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "课程名称",
          prop: "courseName",
        },
        {
          title: "分数",
          prop: "score"
        },
        {
          title: "成绩",
          prop: "result"
        },
        {
          title:"考生详情",
          type:"buttons",
          width:"160",
          btnList:[
            { title:"查看", click: this.show},
          ]
        }
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
      showDialog: false,
      dialogForm: {},

      reverse: false,
      activities: []
    }
  },
  methods: {
    async show(row) {
      this.dialogForm = { ...row };
      let params = {
        planId: this.requestForm.planId,
        courseId: row.courseId,
        userId: row.userId,
      }
      const { code, data } = await queryDetailListAPI(params);
      if (code == 1) {
        this.activities = data;
      }
      this.showDialog = true;
    },
    async initData() {
      // 批次
      const { data: planData } = await getSelectPlanFn();
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
    },

    // 场次
    async getChainSession() {
      this.requestForm.sessionId = "";
      let params = {
        planId: this.requestForm.planId,
      };
      const { code, data } = await getPlanAllSessionByPlan(params);
      if (code == 1) {
        let sessionId = [{ id: "", name: "全部" }, ...data];
        this.$set(this.selectList[1], "data", sessionId);
      } else {
        this.requestForm.sessionId = ''
        this.$set(this.selectList[1], "data", [{ id: "", name: "全部" }]);
      }
    },

    // 课程
    async getPlanCourse(val) {
      this.requestForm.courseId = "";

      let params = {
        sessionId: this.requestForm.sessionId,
        planId: this.requestForm.planId
      }

      const { code, data } = await getPlanCourseList(params)
      if (code == 1) {
        let courseIdList = [{ courseId: "", courseName: "全部" }, ...data];
        this.$set(this.selectList[2], "data", courseIdList);
      } else {
        this.requestForm.courseId = ''
        this.$set(this.selectList[2], "data", [{ id: "", name: "全部" }]);
      }
    },

    search() {
      this.requestForm.page = 1;
      this.getTableData();
    },

    async getTableData() {
      let params = { ...this.requestForm };
      const { code, data } = await examStudentQueryListAPI(params);
      if (code == 1) {
        this.tableData = data.records;
        this.pagination.total = data.total;
      }
    },

    changeNum(num) {
      this.requestForm.size = num
      this.getTableData()
    },

    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
    showBigImg(url) {
      window.open(url, "_blank");
    }
  },
  mounted() {
    this.initData();
  },
  watch: {
    "requestForm.planId": {
      handler(newVal, oldVal) {
        if (newVal) {
          this.requestForm.page = 1;
          this.getChainSession();
          this.getPlanCourse();
          this.getTableData();
        }
      },
      deep: true,
    },
  }
}

</script>
<style scoped lang="less">
.studentInfo {
  // border: 1px solid red;
  // margin-bottom: 24px;
  padding-bottom: 12px;
  margin-bottom: 12px;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px dashed #ccc;
  &>p {
    width: 50%;
    line-height: 24px;
  }
}
.stepUp {
  .radio {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
  }
  .timeline {
    margin-left: 46px;
  }
}
.imgCss{
  padding:3px;
  border:1px solid #ccc; 
  cursor: pointer;
  margin-top:8px;
}
</style>